/* eslint-disable @typescript-eslint/no-explicit-any */
import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Router, RouterLink } from '@angular/router'
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms'

import { firstValueFrom } from 'rxjs'
import { SessionService } from 'superlikers-microsites-api'
import { Control, ControlResolver } from 'superlikers-dynamic-forms'

import { loginControls } from '../../data/loginForm'
import { TogglePasswordDirective } from '@shared/directives'
import { AlertComponent, LoaderComponent, IconComponent } from '@shared/components'

@Component({
  selector: 'login-page',
  imports: [IconComponent, ReactiveFormsModule, RouterLink, TogglePasswordDirective, AlertComponent, LoaderComponent],
  standalone: true,
  templateUrl: './login-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'flex flex-col gap-4'
  }
})
export class LoginPageComponent {
  http = inject(HttpClient)
  fb = inject(FormBuilder)
  router = inject(Router)
  controlResolver = inject(ControlResolver)
  sessionService = inject(SessionService)

  loading = signal<boolean>(false)
  showError = signal<boolean>(false)
  error = signal<string>('')

  controls: Control[] = loginControls

  form = this.fb.group({
    codigo_sap: ['', [Validators.required]],
    password: ['', [Validators.required]]
  })

  async submit() {
    if (this.form.invalid) return

    this.loading.set(true)
    this.error.set('')

    try {
      const data = this.form.value as Record<string, string>
      const response$ = this.sessionService.login(data)
      const response = await firstValueFrom(response$)

      if (response.state === 'success') {
        this.router.navigate(['/'])
      }
    } catch (err: any) {
      if (err.error.state === 'error') {
        this.error.set(err.error.message)
        this.showError.set(true)
      } else {
        window.location.reload()
      }
    } finally {
      this.loading.set(false)
    }
  }

  onAlertClose() {
    this.showError.set(false)
  }
}
